
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-amount-input-config",
})
export default class AmountInputConfig extends ComponentConfigMixins {}
